import { styled } from 'styled-components';
export const ToggleWrapper = styled.label `
  display: ${({ $inline }) => ($inline ? 'inline-flex' : 'flex')};
  align-items: center;
  gap: 8px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  padding-top: ${({ $pseudoLabel }) => ($pseudoLabel ? '32px' : '8px')};
  padding-bottom: 8px;
`;
export const Text = styled.span `
  color: ${({ theme, $disabled }) => ($disabled ? theme.colors.grey100_2 : theme.colors.black_1)};
  ${({ theme, $large }) => ($large ? theme.typography.titleSub : theme.typography.textMedium)}
  ${({ theme }) => theme.typography.weightMedium}
  display: flex;
  align-items: center;
  gap: 4px;
`;
export const Knob = styled.span `
  position: absolute;
  left: 4px;
  bottom: 3px;
  display: flex;
  color: ${({ theme }) => theme.colors.grey00_1};
  transition:
    transform 0.4s,
    color 0.4s;
`;
export const Track = styled.span `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ theme }) => theme.colors.grey30_1};
  transition: background-color 0.4s;
  border-radius: 9999px;
`;
export const ToggleTrack = styled.span `
  position: relative;
  display: inline-block;
  flex-shrink: 0;
  width: 36px;
  height: 20px;

  & input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  & input:checked:not(:disabled) + ${Track} {
    background-color: ${({ theme }) => theme.colors.main};
  }

  &:hover input:not(:disabled) + ${Track}, & input:focus:not(:disabled) + ${Track}, & input:focus-visible:not(:disabled) + ${Track} {
    ${({ theme }) => theme.shadows.focus};
  }

  & input:disabled + ${Track} {
    background-color: ${({ theme }) => theme.colors.grey10_1};
  }

  & input:disabled + ${Track} > ${Knob} {
    color: ${({ theme }) => theme.colors.grey01_1};
  }

  & input:checked + ${Track} > ${Knob} {
    transform: translateX(14px);
  }
`;
